import React from 'react';

/* eslint-disable max-len */
const RefreshIcon = () => (
  <svg className='refresh-icon' viewBox="0 0 98.64 79.54"><path d="M31.67,42.65a4.6,4.6,0,0,0-5.46,3.55L23.83,57.41A30.56,30.56,0,0,1,51.67,10,4.6,4.6,0,0,0,52.38.85,39.76,39.76,0,0,0,14.43,59.64l-7.55-2.8a4.61,4.61,0,0,0-3.19,8.64l20.82,7.71a4.61,4.61,0,0,0,6.1-3.36l4.61-21.72A4.6,4.6,0,0,0,31.67,42.65Z" transform="translate(-0.68 -0.73)"/><path d="M96.58,18,76.29,9a4.6,4.6,0,0,0-6.3,3L64,33.33A4.6,4.6,0,0,0,67.22,39a4.81,4.81,0,0,0,1.24.17,4.61,4.61,0,0,0,4.43-3.37L75.8,25.37A30.53,30.53,0,0,1,46.7,71a4.61,4.61,0,0,0-.78,9.18c1.13.09,2.25.14,3.37.14a39.77,39.77,0,0,0,35.63-57.4l7.93,3.52A4.6,4.6,0,0,0,96.58,18Z" transform="translate(-0.68 -0.73)"/></svg>
);

export default RefreshIcon;
